module.exports = __webpack_public_path__ + "static/media/cancelled_sip_icon.e43cb8a1.svg";